<script>
  import { tick, getContext } from "svelte";

  import { withSymbol } from "../util.js";

  export let data = [];
  export let numberFormat = "";
  export let headers = ["Label", "Value"];
  let show_table = false;

  const resize = getContext("resize");
  const toggle_table = async () => {
    show_table = !show_table;
    await resize();
  };
</script>

<div id="toggle_table">
  <span on:click={toggle_table}>
    {#if show_table}
      Hide Table
    {:else}
      View this Data in a Table
    {/if}
  </span>
</div>
{#if show_table}
  <table>
    <thead>
      <tr>
        {#each headers as h}
          <th>
            {h}
          </th>
        {/each}
      </tr>
    </thead>
    <tbody>
      {#each data as d}
        <tr>
          <td>
            {d.label}
          </td>
          <td>
            {withSymbol(d.data, numberFormat)}
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
{/if}

<style>
  #toggle_table {
    color: #003366;
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 24px;
  }

  #toggle_table span {
    cursor: pointer;
    text-decoration: underline;
  }
  #toggle_table span:hover {
    text-decoration: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
    border: 1px solid #dddddd;
    border-bottom: 0;
    margin-bottom: 32px;
    width: 100%;
    max-width: 675px;
    margin: auto;
  }

  table thead {
    display: table-header-group;
  }
  table thead tr {
    border-bottom: 1px solid #dddddd;
  }

  table thead th {
    padding: 10px 14px;
    text-align: left;
    font-size: 12px;
    font-weight: 600;
  }

  table tbody tr:nth-of-type(even) {
    background: #eeeeee;
  }

  table tbody td {
    position: relative;
    border-bottom: 1px solid #dddddd;
    padding: 12px;
    font-size: 14px;
  }

  table tbody td:first-child {
    border-right: 1px solid #dddddd;
  }
</style>
